import React, { Component } from 'react';
import { MuiThemeProvider, createMuiTheme } from 'material-ui/styles';
import CssBaseline from 'material-ui/CssBaseline';
import Main from './components/Main';
import './App.css';

const theme = createMuiTheme();

const App = () =>
  <MuiThemeProvider theme={theme}>
    <CssBaseline />
    <Main />
  </MuiThemeProvider>;


export default App;



// WEBPACK FOOTER //
// ./src/App.js